/**
 * Typography
 *
 * Master styles for headlines and text.
 * See: https://www.figma.com/file/iLh3LOpdfxU049JzeU10GU/Kittl-UI-Update-2023?node-id=5831%3A18331&t=nsgMdxlBvQIL2mSG-4
 *
 */

import { themeStyle } from '@src/theming';

const UPDATED_SEMI_BOLD = 625;
const UPDATED_P_FONT_WEIGHT = 450;

export const fontThemeStyle = {
  h1FontWeight: UPDATED_SEMI_BOLD,
  h1FontSize: '52px',
  h1LineHeight: '56px',
  h1LetterSpacing: '-0.04em',
  h1FontSizeMobile: '28px',
  h1LineHeightMobile: '32px',
  h1LetterSpacingMobile: '-0.03em',
  h1BFontWeight: UPDATED_SEMI_BOLD,

  h2FontWeight: UPDATED_SEMI_BOLD,
  h2FontSize: '32px',
  h2LineHeight: '36px',
  h2LetterSpacing: '-0.04em',
  h2FontSizeMobile: '22px',
  h2LineHeightMobile: '28px',
  h2LetterSpacingMobile: '-0.03em',
  h2BFontWeight: UPDATED_SEMI_BOLD,

  h3FontWeight: themeStyle.fontMedium,
  h3FontSize: '24px',
  h3LineHeight: '28px',
  h3LetterSpacing: '-0.03em',
  h3FontWeightMobile: UPDATED_SEMI_BOLD,
  h3FontSizeMobile: '18px',
  h3LineHeightMobile: '24px',
  h3LetterSpacingMobile: '-0.03em',
  h3BFontWeight: UPDATED_SEMI_BOLD,

  h4FontWeight: themeStyle.fontMedium,
  h4FontSize: '16px',
  h4LineHeight: '20px',
  h4LetterSpacing: '-0.015em',
  h4BFontWeight: UPDATED_SEMI_BOLD,

  h5FontWeight: themeStyle.fontMedium,
  h5FontSize: '14px',
  h5LineHeight: '20px',
  h5LetterSpacing: '-0.01em',
  h5BFontWeight: UPDATED_SEMI_BOLD,

  h6FontWeight: themeStyle.fontMedium,
  h6FontSize: '12px',
  h6LineHeight: '16px',
  h6LetterSpacing: '-0.01em',
  h6BFontWeight: UPDATED_SEMI_BOLD,

  h6PlusFontWeight: themeStyle.fontBold,
  h6PlusFontSize: '12px',
  h6PlusLineHeight: '16px',
  h6PlusLetterSpacing: '0.02em',
  h6PlusBFontWeight: themeStyle.fontBold,
  h6PlusTextTransform: 'uppercase',

  h7FontWeight: themeStyle.fontMedium,
  h7FontSize: '11px',
  h7LineHeight: '16px',
  h7LetterSpacing: '-0.005em',
  h7BFontWeight: UPDATED_SEMI_BOLD,

  p1FontWeight: UPDATED_P_FONT_WEIGHT,
  p1FontSize: '16px',
  p1LineHeight: '24px',
  p1LetterSpacing: '-0.01em',
  p1BFontWeight: UPDATED_SEMI_BOLD,

  p2FontWeight: UPDATED_P_FONT_WEIGHT,
  p2FontSize: '14px',
  p2LineHeight: '20px',
  p2LetterSpacing: '-0.01em',
  p2BFontWeight: UPDATED_SEMI_BOLD,

  p3FontWeight: UPDATED_P_FONT_WEIGHT,
  p3FontSize: '12px',
  p3LineHeight: '18px',
  p3LetterSpacing: '-0.005em',
  p3BFontWeight: UPDATED_SEMI_BOLD,

  p4FontWeight: UPDATED_P_FONT_WEIGHT,
  p4FontSize: '11px',
  p4LineHeight: '18px',
  p4LetterSpacing: '0',
  p4BFontWeight: UPDATED_SEMI_BOLD,

  buttonFontWeight: UPDATED_SEMI_BOLD,
};
